// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';
import React from 'react';
import Layout from 'antd/lib/layout';

import CanvasLayout from 'components/reference-annotation-page/canvas/grid-layout/canvas-layout';
import ControlsSideBarContainer from 'containers/reference-annotation-page/standard-workspace/controls-side-bar/controls-side-bar';
import CanvasContextMenuContainer from 'containers/reference-annotation-page/canvas/canvas-context-menu';
import ObjectsListContainer from 'containers/reference-annotation-page/standard-workspace/objects-side-bar/objects-list';
import ObjectSideBarComponent from 'components/reference-annotation-page/standard-workspace/objects-side-bar/objects-side-bar';
import CanvasPointContextMenuComponent from 'components/reference-annotation-page/canvas/views/canvas2d/canvas-point-context-menu';
import IssueAggregatorComponent from 'components/reference-annotation-page/review/issues-aggregator';
import RemoveConfirmComponent from 'components/reference-annotation-page/standard-workspace/remove-confirm';
import PropagateConfirmComponent from 'components/reference-annotation-page/standard-workspace/propagate-confirm';

export default function StandardWorkspaceComponent(): JSX.Element {
    return (
        <Layout hasSider className='cvat-standard-workspace'>
            <ControlsSideBarContainer />
            <CanvasLayout />
            <ObjectSideBarComponent />
            <PropagateConfirmComponent />
            <CanvasContextMenuContainer />
            <CanvasPointContextMenuComponent />
            <IssueAggregatorComponent />
            <RemoveConfirmComponent />
        </Layout>
    );
}
